import { IDoctor } from '../../../modules/patients/reducers'
import {
  GET_PROSTHESIS_REFERENCES,
  GET_GAMME_RANGE,
  GET_TRANSMITTER_REFERENCE,
  UPDATE_PATIENT_PROSTHESIS,
  DELETE_PATIENT_PROSTHESIS,
  CREATE_PROSTHESIS,
  GET_PROSTHESIS_REFERENCES_SUMMARY,
  GET_LEADS_REFERENCES_SUMMARY,
  GET_LEADS_REFERENCES,
  GET_TRANSMITTER_REFERENCE_SUMMARY, CREATE_LEAD_REFERENCE, GET_LEAD_REFERENCE_CONNEXIONS,
} from '../constants'
import {ICreateLeadReference, ICreateProsthesis, IUpdatePatientProsthesis} from '../reducers'

export function getProsthesisReferences(
    limit: number | undefined,
  page: number | undefined,
  searchText: string,
  selectedGammes: string[],
  selectedMakerIds: number[],
  resolve: any,
  reject: any,
) {
  return {
    type: GET_PROSTHESIS_REFERENCES,
    limit,
    page,
    searchText,
    selectedGammes,
    selectedMakerIds,
    reject,
    resolve,
  }
}

export function getLeadsReferences(
  limit: number | undefined,
  page: number | undefined,
  searchText: string,
  selectedMakerIds: number[],
  resolve: any,
  reject: any
) {
  return {
    type: GET_LEADS_REFERENCES,
    limit,
    page,
    searchText,
    selectedMakerIds,
    reject,
    resolve,
  }
}

export function getProsthesisReferenceSummary(resolve: any, reject: any) {
  return {
    type: GET_PROSTHESIS_REFERENCES_SUMMARY,
    reject,
    resolve,
  }
}

export function getLeadsReferenceSummary(resolve: any, reject: any) {
  return {
    type: GET_LEADS_REFERENCES_SUMMARY,
    reject,
    resolve,
  }
}

export function getTransmitterReferenceSummary(resolve: any, reject: any) {
  return {
    type: GET_TRANSMITTER_REFERENCE_SUMMARY,
    reject,
    resolve,
  }
}

export function getTransmitterReference(
  size: number | undefined,
  page: number | undefined,
  searchText: string,
  selectedMakerIds: number[],
  resolve: any,
  reject: any,
) {
  return {
    type: GET_TRANSMITTER_REFERENCE,
    size,
    page,
    searchText,
    selectedMakerIds,
    resolve,
    reject,
  }
}

export function getGammeRange(
  size: number,
  page: number,
  resolve: any,
  reject: any,
) {
  return {
    type: GET_GAMME_RANGE,
    size,
    page,
    resolve,
    reject,
  }
}

export function updatePatientProsthesis(
  infos: IUpdatePatientProsthesis,
  method: string,
  implantationId: number,
  patientId: number,
  cardioAttent: IDoctor,
  cardioBilling: IDoctor,
  cardioImplant: IDoctor,
  resolve: any,
  reject: any,
) {
  return {
    type: UPDATE_PATIENT_PROSTHESIS,
    infos,
    method,
    implantationId,
    patientId,
    cardioAttent,
    cardioBilling,
    cardioImplant,
    reject,
    resolve,
  }
}

export function createProsthesis(
  data: ICreateProsthesis,
  resolve: any,
  reject: any,
) {
  return {
    type: CREATE_PROSTHESIS,
    data,
    reject,
    resolve,
  }
}

export function createLeadReference(
    data: ICreateLeadReference,
    resolve: any,
    reject: any
) {
  return {
    type: CREATE_LEAD_REFERENCE,
    data,
    reject,
    resolve,
  }
}

export function getLeadReferenceConnexions(
    resolve: any,
    reject: any
) {
  return {
    type: GET_LEAD_REFERENCE_CONNEXIONS,
    reject,
    resolve,
  }
}

export function deletePatientProsthesis(id: number, resolve: any, reject: any) {
  return { type: DELETE_PATIENT_PROSTHESIS, id, reject, resolve }
}
